import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBentleyComponent } from './simple-icons-bentley.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBentleyComponent ],
    exports:      [ SimpleIconsBentleyComponent ],
    bootstrap:    []
})
export class SimpleIconsBentleyModule {}
